//@flow
import BaseEntitySelectors from 'common/redux/selectors/BaseEntitySelectors';
import { createSelector } from 'reselect';

class PjpSelectors extends BaseEntitySelectors {
    constructor() {
        super('pjp');
    }

    getSelectedPjp = createSelector(
        [this.getEntities, (state, props) => props.match.params.pjpId],
        (entities, pjpId) => {
            return (
                entities &&
                entities.entities.find(entity => entity.id === pjpId)
            );
        }
    );

    getTotalRidersCount = createSelector([this.getSelectedPjp], selectedPjp => {
        return selectedPjp && selectedPjp.ridersInfo.riderIds.size;
    });

    getTotalOutletsCount = createSelector(
        [this.getSelectedPjp],
        selectedPjp => {
            return selectedPjp && selectedPjp.outletsInfo.outletIds.size;
        }
    );
}

export default new PjpSelectors();
